export default __webpack_public_path__ + "static/media/scb.9b2e532a.svg";